module.exports = __webpack_public_path__ + "static/media/test-icon.fd74fbb1.svg";